import K from "utilities/constants";
import { stringSorting } from "utilities/tableUtility";
import { StatusTag } from "common/components/statusTag/statusTag";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import { Flex } from "common/components/flex/flex";
import { checkNullPlaceHolder } from "utilities/generalUtility";

const candidateNameTooltip = (params) => (
  <div className="client-list-tooltip">
    {`${params.data.candidate?.firstName} ${params.data.candidate?.lastName}`}
  </div>
);

const candidateTypeGetter = (params) =>
  params.data?.candidateType ?? params.data?.hireType;

const candidateTypeTooltip = (params) => (
  <div className="client-list-tooltip">
    {checkNullPlaceHolder(K.CandidateType[params.value])}
  </div>
);

const statusTooltip = (params) => (
  <div className="client-list-tooltip">{params.data.status.name}</div>
);

const subStatusTooltip = (params) => (
  <div className="client-list-tooltip">{params.data.subStatus.name}</div>
);

const candidateStatusTooltip = (params) => (
  <div className="client-list-tooltip">
    {params.data?.candidateStatus?.name}
  </div>
);

const candidateStatusRenderer = (params) =>
  params.data?.candidateStatus?.name ?? "N/A";

const candidateIdRenderer = (params) => params.data?.candidate.id ?? "N/A";

const candidateIdTooltip = (params) => (
  <div className="client-list-tooltip">{params.data?.candidate?.id}</div>
);

const candidateEmailRenderer = (params) =>
  params.data?.candidate.email ?? "N/A";

const candidateEmailTooltip = (params) => (
  <div className="client-list-tooltip">{params.data?.candidate?.email}</div>
);

export const getColumns = () => [
  {
    ...DefaultColumnOptions.Id,
    sort: "asc",
    field: "candidates.id",
    tooltipField: "candidate.id",
    checkboxSelection: true,
    cellRenderer: candidateIdRenderer,
    tooltipComponent: candidateIdTooltip,
  },
  {
    headerName: "Name",
    field: "candidates.firstName",
    sortable: true,
    tooltipField: "candidates.firstName",
    tooltipComponent: candidateNameTooltip,
    getQuickFilterText: (params) => {
      return [
        params.data.candidate?.firstName,
        params.data.candidate?.lastName,
      ].join(" ");
    },
    cellRenderer: (params) => (
      <div>
        {[
          params.data.candidate?.firstName,
          params.data.candidate?.lastName,
        ].join(" ")}
      </div>
    ),
  },
  {
    headerName: "Email",
    field: "candidates.email",
    sortable: true,
    tooltipField: "candidates.email",
    cellRenderer: candidateEmailRenderer,
    tooltipComponent: candidateEmailTooltip,
  },
  {
    headerName: "Mobile Number",
    field: "candidates.mobileNumber",
    sortable: true,
    tooltipField: "candidates.mobileNumber",
    getQuickFilterText: (params) => params.candidate.mobileNumber,
    cellRenderer: (params) =>
      checkNullPlaceHolder(params.data.candidate.mobileNumber),
  },
  {
    headerName: "Candidate Type",
    field: "candidateType",
    sortable: true,
    valueGetter: candidateTypeGetter,
    tooltipValueGetter: candidateTypeGetter,
    getQuickFilterText: (params) =>
      K.CandidateType[candidateTypeGetter(params)],
    cellRenderer: (params) =>
      checkNullPlaceHolder(K.CandidateType[params.value]),
    tooltipComponent: candidateTypeTooltip,
  },
  {
    headerName: "Candidate Status",
    field: "candidate_statuses.id",
    sortable: true,
    tooltipField: "candidateStatus",
    getQuickFilterText: candidateStatusRenderer,
    cellRenderer: candidateStatusRenderer,
    tooltipComponent: candidateStatusTooltip,
  },
  {
    headerName: "Current Title",
    field: "candidates.currentTitle",
    sortable: true,
    tooltipField: "candidates.currentTitle",
    getQuickFilterText: (params) => params.candidate.currentTitle,
    cellRenderer: (params) =>
      checkNullPlaceHolder(params.data.candidate.currentTitle),
  },
  {
    headerName: "Status",
    field: "statuses.name",
    sortable: true,
    tooltipField: "statuses.name",
    getQuickFilterText: (params) => params.data.status.name,
    tooltipComponent: statusTooltip,
    comparator: (a, b) => stringSorting(a, b, "name"),
    cellRenderer: (params) => (
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <StatusTag status={params.data.status.name} />
      </Flex>
    ),
  },
  {
    headerName: "Sub Status",
    field: "subStatuses.name",
    sortable: true,
    tooltipField: "subStatuses.name",
    tooltipComponent: subStatusTooltip,
    getQuickFilterText: (params) => params.data.subStatus.name,

    comparator: (a, b) => stringSorting(a, b, "name"),
    cellRenderer: (params) => (
      <Flex align="center" justify="center" style={{ height: "100%" }}>
        <StatusTag
          status={params.data.subStatus.name}
          parentStatus={params.data.status.name}
        />
      </Flex>
    ),
  },
];
